import {  Form, FC, useMemo } from 'external/react'

import FormTextfield from 'components/FormTextfield'
import useParent from 'context/parent-context/hook'

type AddUserFormProps =  {
    errors: any    
}

const NewUserForm: FC<AddUserFormProps> = props => {

    const {errors} = props
    const {update, state: {modals: {addUser}}} = useParent()

	function createFieldProps (placeholder, fieldName, maxLength?) {
		return {
			placeholder,
			maxLength,
			fieldName,
			value: addUser[fieldName],
			submitted: errors.submitted,
			error: errors[fieldName],
			onChange: (e) => {
				update({modals: {addUser: {[fieldName]: {$set: e.target.value.trim()}}}})
			}
		}
	}

    return (
        <fieldset className='border rounded-3 p-3 flex-grow-1 mr-2'>
            <legend className='float-none w-auto px-2 fs-6'>
                Información de usuario
            </legend>
        <Form>
                <FormTextfield {...createFieldProps('Nombre', 'first_name', 25)} />
                <FormTextfield {...createFieldProps('Apellido', 'last_name', 25)} />
                <FormTextfield {...createFieldProps('Correo', 'email')} />
                <FormTextfield {...createFieldProps('Télefono', 'phone')} />
        </Form>
        </fieldset>
    )
}

export {NewUserForm as default}